export const TASK_CONSTANTS = {
    TASK_TAGS: {
        ALT_ADDRESS: 'alt_address',
        CLUSTER: 'cluster',
        HOME: 'address_active',
        LAPTOP_TRACK: '12_20_2',
        LAPTOP_TRACK_CLOSEST: '12_20_3',
        LAPTOP_GPS_CLOSEST: '12_20_0',
        LAPTOP_TRAVEL_LINES: '20_00_0',
        PHONE_TRACK: '12_30_1',
        PHONE_TRACK_CLOSEST: '12_20_3',
        PHONE_TRAVEL_LINES: '20_00_1',
        POLY: 'poly',
        STOP_POINTS: '12_30_3',
        SUSPECT: 'suspect',
        TASK: 'task',
        VALID_ALT: '10_20_6_1',
        SUSPECT_ALT: '10_30_2_1',
        NO_DATA: "10_50_0",
        NO_DATA_ALT: "10_50_1",
        OTHER: "10_60_0"
    },
    TASK_TYPES: {
        EROC: 'EROC',
		MROC: 'MROC',
        UNDEFINED: 'UNDEFINED'
    },
    TASK_STATUS: {
        COMPLETED: 'COMPLETED',
        CONFIRMED: 'CONFIRMED',
        CORRECTED: 'CORRECTED',
        NOTREVIEWED: 'NOTREVIEWED',
        UNASSIGNED: 'UNASSIGNED',
        UNDER_REVIEW: 'UNDER_REVIEW',
        VALID: 'VALID'
    },
    TASK_QUERY_TYPES: {
		BY_STATUS: 0,
        BY_STAFF: 1,
		BY_SPID: 2
    }
};
